import posthog from 'posthog-js';
import type { AxiosError } from 'axios';

/**
 * Captures API error in PostHog with full context
 */
export function captureApiErrorInPostHog(error: AxiosError): void {
  const config = error.config;
  const response = error.response;
  const responseData = response?.data;

  const apiEndpoint = config?.url || 'unknown';
  const method = config?.method?.toUpperCase() || 'UNKNOWN';
  const statusCode = response?.status || 'network_error';

  const errorTitle = `API ${method} ${statusCode}: ${apiEndpoint}`;

  posthog.captureException(new Error(errorTitle), {
    // API Request Details
    api_endpoint: apiEndpoint,
    api_method: method,
    api_base_url: config?.baseURL,
    api_full_url: config?.baseURL
      ? `${config.baseURL}${apiEndpoint}`
      : apiEndpoint,

    // Response Details
    status_code: statusCode,
    status_text: response?.statusText,

    // Error Details
    error_raw_data: responseData,
  });
}
